import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useAccessHistory = () => {
  const [events, setEvents] = useState([]);
  const [nextCursor, setNextCursor] = useState(null);
  const [pending, setPending] = useState("initial");
  const [error, setError] = useState(null);
  const controller = useRef(null);
  const sequence = useRef(0);

  const fetchPage = useCallback(async (before = null) => {
    controller.current?.abort();
    const current = new AbortController();
    controller.current = current;
    const request = ++sequence.current;
    setPending(before ? "more" : "initial");
    setError(null);
    try {
      const { data } = await axios.get(`${API}/admin/access-history`, {
        withCredentials: true, signal: current.signal, timeout: 15000,
        params: { limit: 25, ...(before ? { before } : {}) },
      });
      if (request !== sequence.current || current.signal.aborted) return;
      setEvents((previous) => before ? [...previous, ...data.events] : data.events);
      setNextCursor(data.next_cursor);
    } catch (err) {
      if (axios.isCancel(err) || current.signal.aborted || request !== sequence.current) return;
      const status = err.response?.status;
      setError({ status, message: status === 401 ? "Sesiunea a expirat. Autentifică-te din nou." : "Istoricul nu a putut fi încărcat. Încearcă din nou." });
      if (status === 401 || status === 403) { setEvents([]); setNextCursor(null); }
    } finally {
      if (request === sequence.current && !current.signal.aborted) setPending(null);
    }
  }, []);

  const cancelRequest = useCallback(() => controller.current?.abort(), []);
  useEffect(() => {
    fetchPage();
    return cancelRequest;
  }, [fetchPage, cancelRequest]);

  return { events, nextCursor, pending, error, refresh: () => fetchPage(), loadMore: () => nextCursor && fetchPage(nextCursor) };
};